import MenuHeader from "../../common/MenuHeader"
import RightGoogleMap from "../../common/RightGoogleMap"
import SetUpLayout from "../../common/SetUpLayout"
import LayoutMain from "./LayoutMain"

type Props = {}

const Sensor = (props: Props) => {
  return (
    <SetUpLayout
      title='Sensor'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }}
      />}
    >
      <LayoutMain title="Data 8 of 9" subtitle="Sensor" />
    </SetUpLayout>
  )
}

export default Sensor